import { useState } from "react";
import { ClipboardList, X } from "lucide-react";
import { DropWarning, WrongProduct } from "@/components/drop/DropWarning";
import { useT } from "@/lib/i18n";

// Over 90%: the driver must confirm they re-sticked and checked the console before the drop is logged.
export function LogConfirm({ sf, match, needRestick, mismatchText, onCancel, onLog }) {
  const t = useT();
  const [ok, setOk] = useState(!needRestick);
  const [prodOk, setProdOk] = useState(!mismatchText);
  return (
    <div className="modal-backdrop" data-testid="log-confirm" role="dialog" aria-modal="true">
      <div className="modal log-confirm">
        <div className="po-head"><b>{t(needRestick && mismatchText ? "Log a drop over 90% with the wrong product?" : needRestick ? "Log a drop over 90%?" : "Log a drop with a product mismatch?")}</b><span className="card-sub" />
          <button type="button" className="icon-plain" aria-label={t("Close")} onClick={onCancel} data-testid="log-confirm-close"><X size={18} /></button></div>
        {needRestick && <DropWarning sf={sf} testid="log-confirm-warning" />}
        <WrongProduct text={mismatchText} testid="log-confirm-product" />
        {match}
        {needRestick && (
          <label className="confirm-check" data-testid="log-confirm-check-label">
            <input type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} data-testid="log-confirm-check" />
            <span>{t("I re-sticked the tank and checked the console")}</span>
          </label>
        )}
        {mismatchText && (
          <label className="confirm-check" data-testid="log-confirm-product-check-label">
            <input type="checkbox" checked={prodOk} onChange={(e) => setProdOk(e.target.checked)} data-testid="log-confirm-product-check" />
            <span>{t("I checked the BOL, the fill cap color and the tank's product")}</span>
          </label>
        )}
        <div className="action-row">
          <button type="button" className="ghost-btn" onClick={onCancel} data-testid="log-confirm-cancel">{t("Cancel")}</button>
          <button type="button" className="primary-btn danger-btn" disabled={!ok || !prodOk} onClick={onLog} data-testid="log-confirm-log"><ClipboardList size={16} />{t("Log anyway")}</button>
        </div>
      </div>
    </div>
  );
}

export function OverflowBlock({ sf, onEdit, onClose, mismatchText }) {
  const t = useT();
  return (
    <div className="overflow-block" data-testid="overflow-block" role="alertdialog" aria-modal="true">
      <div className="overflow-inner">
        <button type="button" className="overflow-close" onClick={onClose} aria-label={t("Close")} data-testid="overflow-close"><X size={22} /></button>
        <b className="overflow-head">{t("SPILL RISK - TANK WILL OVERFLOW BY {x} GAL", { x: Math.round(sf.overflow).toLocaleString("en-US") })}</b>
        <p>{t("Logging is off until the drop fits. Drop no more than {g} gal.", { g: sf.room90.toLocaleString("en-US") })}</p>
        <WrongProduct text={mismatchText} testid="overflow-product-warning" />
        <button type="button" className="primary-btn" onClick={onEdit} data-testid="overflow-edit">{t("Change the gallons")}</button>
        <button type="button" className="ghost-btn overflow-dismiss" onClick={onClose} data-testid="overflow-dismiss">{t("Close")}</button>
      </div>
    </div>
  );
}
